import img01 from "./../../../assets/images/WelfareStevedores.png";// Adjust the path as necessary

function GBVOverviewTab() {
  return (
    <>
      <div className="service-title font-700 mb-3 text-uppercase">
        Gender Based Violence 
        <p className="text-primary-color mb-3">
          <span className="text-orange-ef3e33 font-400"> (GBV, violence and harassment, including sexual harassment, bullying and sexual assault.)</span>
        </p>
         
      </div>

      <div className="row g-3 g-sm-4 g-md-5">
        <div className="col-lg">
           <div className="service-title font-700 mb-3 text-uppercase">
           </div>

          <p className="text-primary-color mb-3">
          Gender-Based Violence (GBV) is a term used to describe violence of various types directed at an individual based on their gender. It can take the form of violence and harassment, including sexual harassment, bullying and sexual assault. In some cases, it can manifest itself as emotional abuse, psychological abuse, body shaming, unfair discrimination and economic abuse. The list is long. GBV is not only confined to homes but also takes place at workplaces. 
          </p>

           <p className="text-primary-color mb-3">
            The Seafarer Workforce Report, published in 2021 by Baltic and International Maritime Council (BIMCO) and Institute of Chartered Shipbrokers (ICS), reports that 1.89 million seafarers are currently operating over 74,000 vessels.  The FAO’ State of World Fisheries and Agriculture 2022 report states that the world had an estimated 4.1 million fishing vessels in 2020, and the industry employs an estimated 37.9 million fishers.
          </p>
          
          {/* <ul class="green-star-ul">
            <li>In reporting Crew complaints that falls within MLC kindly ensure that you have followed the guidelines provided in Marine Notice No. 48 of 2020 – Onboard Complaints Procedure. </li>
              
          </ul>   */}
          
               

        </div>
        <div className="col-lg-5">
          <div className="row g-3 g-sm-3 g-md-4 g-lg-4">
            <div className="col-lg-12 col-md-6 col-sm-6">
              <img src={img01} className="img-fluid rounded-1" alt="" />
            </div>
            {/* <div className="col-lg-12 col-md-6 col-sm-6">
              <img src={img01} className="img-fluid rounded-1" alt="" />
            </div> */}
          </div>        
        </div>
         
      </div>
      {/* <ul class="green-star-ul">
            <li>In reporting Crew complaints that falls within MLC kindly ensure that you have followed the guidelines provided in Marine Notice No. 48 of 2020 – Onboard Complaints Procedure. </li>
            
            <li>In reporting complaints falling outside the MLC i.e. fishing vessels, report the complaint to the company by following company’s procedures and if not satisfied contact any SAMSA office nearest to you, alternatively you can forward your complaint to welfare@samsa.org.za </li>
                 
          </ul>   */}
      <p className="text-primary-color mb-3">
          Seafarers are encouraged to report any complaints by following their company’s Onboard Complaint Procedures and escalate to SAMSA if you are unhappy with the handling or wish to challenge the outcome of the case. However, seafarers have a right to report any issue directly to SAMSA or any Authority if they feel the issue warrants urgent intervention (i.e. sexual assault, violence etc) or feel intimidated to report to the line management or company. 
          </p>
      <p className="text-primary-color">
          Please note SAMSA’s jurisdiction is limited to South African flagged vessels and foreign vessels which at the time of the incident is/was in South African territory. 
          </p>  

    </>
  );
}

export default GBVOverviewTab;